import { Products } from "@/money"

export default function Pricing() {
  return (
    <div className="p-8">
      <Products page="pricing" />
    </div>
  )
}
